import HttpService from './http';

export default class MarketplaceHttpService {
  static get = async marketplace_uid => {
    const url = `/v2.0/events/${marketplace_uid}`;
    return await HttpService.get(url, false);
  };
}
